import { render, staticRenderFns } from "./PastLeakAlertsTable.vue?vue&type=template&id=dfc3a160"
import script from "./PastLeakAlertsTable.vue?vue&type=script&lang=js"
export * from "./PastLeakAlertsTable.vue?vue&type=script&lang=js"
import style0 from "./PastLeakAlertsTable.vue?vue&type=style&index=0&id=dfc3a160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports